// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;We have sinned like our forebears;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;we have done wrong and dealt wickedly.<br> </p> </div></div>";
// Exports
module.exports = code;